import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  initState as initRequestStatusState,
  requestInProcess,
  requestFinished,
  setCodeResponse
} from '../../../../common/reducers/_requestStatus/reducer';
import {
  initState as initStateFormErrors,
  setErrors,
  clearErrors
} from '../../../../common/reducers/_formErrors/reducer';
import { sendForm, initState, setTrueFormDisabled } from './actions';
import { selectFormBody } from './selectors';
import { timeoutCall } from '../../../../utils/sagaHalper';
import UserOutputAccountsService from '../../services/UserOutputAccountsService';
import * as clientNoticesActions from '../../../main/reducers/static/states/clientNotices/reducer';

function* saveAuthUserOutputAccount(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  const modifyFormBody = Object.keys(formBody).reduce((r, e) => {
    // eslint-disable-next-line no-param-reassign
    if (formBody[e] !== '') r[e] = formBody[e];
    return r;
  }, {});
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserOutputAccountsService.saveAuthUserOutputAccount,
      modifyFormBody
    );
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        yield put(setTrueFormDisabled(reducerName));
        // TODO Статика, нужно передавать с сервера
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: 'Номер счета успешно сохранен!'
          })
        );
      }
      yield put(setCodeResponse(reducerName, response.status));
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initStateFormErrors(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(
      sendForm(reducerName).type,
      saveAuthUserOutputAccount,
      reducerName
    ),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/saga.js